<template>
    <div class="maincont child system-setting">
      <div class="ef--inner">
        <!-- Tab links -->
        <div class="setting-tab">
            <ul>
                <li
                    v-for="(item, index) in tabs"
                    :class="{ 'active' : currentTab === item.id }"
                    class="nav-item"
                    @click="selectTabs(item.id)"
                    >
                    <span>{{ item.name }}</span>
                </li>
            </ul>
        </div>

        <div class="page-info page-info-frame">
            <!-- import_export_tab -->
            <div id="import_export_tab" class="import-export-tab" v-show="isShowImportExportTab">
                <div class="wrap-content">
                    <div class="form-group group-input">
                        <label class="label-title">電衛門共通</label> <br />
                        <label class="label-title">システム設定ファイル：</label>
                        <input type="text" class="input-field" v-model="fileName" readonly />
                        <input 
                            type="file" 
                            class="hide" 
                            ref="refImportFile"
                            name="import_file" 
                            data-vv-as="システム設定ファイル" 
                            v-validate="'required|size:10240|ext:xls,xlsx'"
                            data-vv-scope="import_export_tab"
                            @change="onChangeImportExcel" />
                        <a href="javascript:void(0);" class="bt-cyan choose-upload-file" @click="onChooseImportFile">ファイル選択</a>
                        <div class="err_message"> {{ errors.first("import_export_tab.import_file") }}</div>
                    </div>
                    <div class="form-group group-button">
                        <div class="group-left">
                            <button type="button" class="bt-cyan" @click="onImportFile">Import</button>
                        </div>
                        <div class="group-right">
                            <button type="button" class="bt-cyan" @click="onExportFile">Export</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 設備区分設定 -->
            <div id="equipment_item_tab" class="equipment-item-tab" v-show="isShowEquipmentItemTab">
                <ValidationObserver ref="observerEquipmentItem">
                <div class="wrap-content">
                    <div class="left-content"></div>
                    <div class="scroll middle-content" style="height: 580px;">
                        <table id="maintenance-table" class="normal-table">
                            <thead>
                            <tr>
                                <th class="d-mw-30">No.</th>
                                <th>設備区分名</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in equipmentItemList" v-bind:key="index">
                                <td>{{ index + 1 }}</td>
                                <td>
                                    <ValidationProvider
                                        rules="max:64"
                                        v-slot="{ errors }"
                                        name="設備区分名"
                                    >
                                        <input
                                            type="text"
                                            class="cell-input-field"
                                            v-model="item.equipment_name"
                                            maxlength="65"
                                            data-vv-scope="equipment_item_tab"
                                        />
                                        <div class="err_message">{{ errors[0] }}</div>
                                    </ValidationProvider>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="right-content">
                        <button type="button" class="bt-cyan" @click="onRegisterEquipmentItem"> 登録</button>
                        <button type="button" class="bt-cyan bt-gray" @click="onResetEquipmentItem">キャンセル</button>
                    </div>
                </div>
                </ValidationObserver>
            </div>

            <!-- エリア名称設定 -->
            <div id="area_info_tab" class="area-info-tab" v-show="isShowAreaInfoTab">
                <ValidationObserver ref="observerAreaInfo">
                <div class="wrap-content">
                    <div class="left-content">
                        <div class="cluster-selection">
                            <label>クラスタ選択</label>
                            <ul>
                                <li 
                                    v-for="(item, index) in clusterList" 
                                    v-bind:key="item.cluster_id"
                                    :class="{'active': areaInfoClusterId === item.cluster_id}"
                                    @click="onChangeAreaInfoClusterId(item.cluster_id)">
                                    {{ 'クラスタ' + item.cluster_id }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="scroll middle-content" style="height: 580px;">
                        <table id="maintenance-table" class="normal-table">
                            <thead ref="ref-area-info">
                                <tr>
                                    <th class="d-mw-30">エリアID</th>
                                    <th>エリア名称</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in areaInfoList" v-bind:key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <ValidationProvider
                                            rules="max:64"
                                            v-slot="{ errors }"
                                            name="エリア名称"
                                        >
                                            <input
                                                type="text"
                                                class="cell-input-field text-left"
                                                v-model="item.area_name"
                                                maxlength="65"
                                                data-vv-scope="area_info_tab"
                                            />
                                            <div class="err_message">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="right-content">
                        <button type="button" class="bt-cyan" @click="onRegisterAreaInfo">登録</button>
                        <button type="button" class="bt-cyan bt-gray" @click="onResetAreaInfo">キャンセル</button>
                    </div>
                </div>
                </ValidationObserver>
            </div>
            <!-- 単位名称設定 -->
            <div id="unit_info_tab" v-show="isShowUnitInfoTab">
                <ValidationObserver ref="observerUnitInfo">
                <div class="wrap-content">
                    <div class="left-content"></div>
                    <div class="scroll middle-content" style="height: 580px;">
                        <table id="maintenance-table" class="normal-table">
                            <thead>
                                <tr>
                                    <th class="d-mw-30">No.</th>
                                    <th>単位名称</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in unitInfoList" v-bind:key="item.index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <ValidationProvider
                                            rules="max:16"
                                            v-slot="{ errors }"
                                            name="単位名称"
                                        >
                                            <input
                                                type="text"
                                                class="cell-input-field"
                                                v-model="item.unit_name"
                                                maxlength="17"
                                                data-vv-scope="unit_info_tab"
                                            />
                                            <div class="err_message">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <div class="right-content">
                        <button type="button" class="bt-cyan" @click="onRegisterUnitInfo">登録</button>
                        <button type="button" class="bt-cyan bt-gray" @click="onResetUnitInfo">キャンセル</button>
                    </div>
                </div>
                </ValidationObserver>

            </div>
            <!-- ON/OFF名称設定 -->
            <div id="on_off_display_name_tab" v-show="isShowOnOffDisplayNameTab">
                <ValidationObserver ref="observerOnOffDisplayName">
                <div class="wrap-content">
                    <div class="left-content"></div>
                    <div class="scroll middle-content" style="height: 580px;">
                        <table id="maintenance-table" class="normal-table">
                            <thead>
                                <tr>
                                    <th class="d-mw-30">No.</th>
                                    <th>ON時名称</th>
                                    <th>OFF時名称</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in onOffDisplayNameList" v-bind:key="item.index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <ValidationProvider
                                            rules="max:64"
                                            v-slot="{ errors }"
                                            name="ON時名称"
                                        >
                                            <input
                                                type="text"
                                                class="cell-input-field"
                                                v-model="item.on_name"
                                                maxlength="65"
                                                data-vv-scope="on_off_display_name_tab"
                                            />
                                            <div class="err_message">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </td>
                                    <td>
                                        <ValidationProvider
                                            rules="max:64"
                                            v-slot="{ errors }"
                                            name="OFF時名称"
                                        >
                                            <input
                                                type="text"
                                                class="cell-input-field"
                                                v-model="item.off_name"
                                                maxlength="65"
                                                data-vv-scope="on_off_display_name_tab"
                                            />
                                            <div class="err_message">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="right-content">
                        <button type="button" class="bt-cyan" @click="onRegisterOnOffNameDisplay">登録</button>
                        <button type="button" class="bt-cyan bt-gray" @click="onResetOnOffNameDisplay">キャンセル</button>
                    </div>
                </div>
                </ValidationObserver>
            </div>

             <!-- 警報名称設定 -->
            <div id="alert_info_tab" v-show="isShowAlertInfoTab">
                <ValidationObserver ref="observerAlertInfo">
                <div class="wrap-content">
                    <div class="left-content"></div>
                    <div class="scroll middle-content" style="height: 580px;">
                        <table id="maintenance-table" class="normal-table">
                            <thead>
                                <tr>
                                    <th class="d-mw-30">No.</th>
                                    <th>ON名称</th>
                                    <th>OFF名称</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in alertInfoList" v-bind:key="item.index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <ValidationProvider
                                            rules="max:64"
                                            v-slot="{ errors }"
                                            name="ON名称"
                                        >
                                            <input
                                                type="text"
                                                class="cell-input-field"
                                                v-model="item.on_name"
                                                maxlength="65"
                                                data-vv-scope="alert_info_tab"
                                            />
                                            <div class="err_message">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </td>
                                    <td>
                                        <ValidationProvider
                                            rules="max:64"
                                            v-slot="{errors }"
                                            name="OFF名称"
                                        >
                                            <input
                                                type="text"
                                                class="cell-input-field"
                                                v-model="item.off_name"
                                                maxlength="65"
                                                data-vv-scope="alert_info_tab"
                                            />
                                            <div class="err_message">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="right-content">
                        <button type="button" class="bt-cyan" @click="onRegisterAlertInfo">登録</button>
                        <button type="button" class="bt-cyan bt-gray" @click="onResetAlertInfo">キャンセル</button>
                    </div>
                </div>
                </ValidationObserver>
            </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  /* eslint-disable */
  import { ValidationProvider, ValidationObserver } from "vee-validate";

  export default {
    name: "system-setting",
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data: function() {
      return {
        // Tabs
        currentTab: "import_export_tab",
        tabs: [
          {
            id: "import_export_tab",
            name: "Import/Export",
          },
          {
            id: "area_info_tab",
            name: "エリア名称設定",
          },
          {
            id: "unit_info_tab",
            name: "単位名称設定",
          },
          {
            id: "on_off_display_name_tab",
            name: "ON/OFF名称設定",
          },
          {
            id: "alert_info_tab",
            name: "警報名称設定",
          },
          {
            id: "equipment_item_tab",
            name: "設備区分設定",
          },
        ],

        fileData: null,
        fileName: '',
        equipmentItemList: [],
        clusterList: [],
        areaInfoList: [],
        areaInfoClusterId: 0,
        unitInfoList: [],
        onOffDisplayNameList: [],
        alertInfoList: [],
      };
    },
  
    methods: {
      //-----------------------COMMON METHODS--------------------
      // Select tabs
      selectTabs: function(tabName) {
        this.currentTab = tabName;
  
        switch (this.currentTab) {
          case "equipment_item_tab":
            this.getEquipmentItem();
            break;
          case "area_info_tab":
            this.getClusterInfo();
            break;
          case "unit_info_tab":
            this.getUnitInfo()
            break;
          case "on_off_display_name_tab":
            this.getOnOffNameDisplay()
            break;
          case "alert_info_tab":
            this.getAlertInfo()
            break;
        }
      },
      // ------------------END COMMON METHODS--------------------  
      onChangeImportExcel: function() {
            this.$validator.validateAll('import_export_tab').then(valid => {
                if (valid) {
                    this.fileData = this.$refs.refImportFile.files[0]
                    this.fileName = this.fileData.name
                } else {
                    this.fileData = null
                    this.fileName = ''
                }
            })
        },
        onChooseImportFile: function() {
            // reset file
            this.$refs.refImportFile.value = ''
            this.fileData = null;
            this.fileName = ''
            this.$refs.refImportFile.click()
        },
        onImportFile: function() {
            this.$validator.validateAll('import_export_tab').then(valid => {
                if (valid) {
                    const formData = new FormData();
                    formData.append("file", this.fileData); 
                    this.$store.dispatch("setLoading", true)
                    this.$axios
                    .post(`/srv/api/system_setting/import_csv`, formData, {
                        withCredentials: true,
                    })
                    .then(response => {
                        const data = response.data;
                        this.$store.dispatch("setLoading", false)
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][/srv/api/system_setting/import_csv]: OK");
                                
                                alert("システム設定を反映しました。");
                            } else {
                                console.log("[POST]/srv/api/system_setting/import_csv]: error");
                                alert("システム設定の反映に失敗しました。");
                            }
                        } else {
                            console.log("[POST][/srv/api/system_setting/import_csv]: error");
                            alert("システム設定の反映に失敗しました。");
                        }
                    })
                    .catch(error => {
                        this.$store.dispatch("setLoading", false)
                        console.log(error);
                    });
                }
            })
        },
        onExportFile: function() {
            this.$store.dispatch("setLoading", true)
            const request = {
                withCredentials: true,
                responseType: "blob",
                exposedHeaders: ["Content-Disposition"]
            };
            this.$axios
            .get(`/srv/api/system_setting/export_csv`, request)
            .then(response => {
                const dateTime = (new Date()).toISOString().split('T')[0]
                const fileType = '.xlsx'
                const filename = '電衛門システム設定' + dateTime + fileType || '電衛門システム設定.xlsx'

                if (
                    response.headers["content-type"].indexOf("application/json") != -1
                ) {
                    alert("ダウンロードできませんでした");
                    this.$store.dispatch("setLoading", false)
                    return;
                }
                const dl = document.getElementById("downloadLink");
                if (dl != undefined) dl.parentNode.removeChild(dl);

                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' }));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("id", "downloadLink");
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                this.$emit("close");
                this.$store.dispatch("setLoading", false)
            })
            .catch(error => {
                this.$store.dispatch("setLoading", false)
                console.log(error);
            });
        },
        
      // ------------------TAB CLASSIFICATION-------------------
      // Get equipment item from API
      getEquipmentItem: function() {
        this.$validator.reset('equipment_item_tab')
        this.$axios
          .get(`/srv/api/equipment_item`, {
            withCredentials: true,
          })
          .then((response) => {
            console.log("[GET][api/equipment_item] : OK");
            if (typeof response.data == "object") {
                let data = response.data.equipment_items;
                const length = data.length
                for(let i = length; i < 30; i++) {
                    data.push({
                        equipment_id:i+1,
                        equipment_name : ''
                    })
                }
                this.equipmentItemList = data
            } else {
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      onResetEquipmentItem: function() {        
        this.getEquipmentItem()
      },
      async onRegisterEquipmentItem() {
        const isValid = await this.$refs.observerEquipmentItem.validate();

        this.$validator.validateAll('equipment_item_tab').then(valid => {
            if (isValid) {
                const ans = confirm('保存しますか？')
                if (ans) {
                    const params = {
                        'equipment_items': this.equipmentItemList
                    };
                    this.$axios
                    .post(`/srv/api/equipment_item`, params, {
                        withCredentials: true
                    })
                    .then(response => {
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][api/equipment_item] : OK")
                                alert("登録が完了しました。");
                                this.getEquipmentItem()
                            } else {
                                console.log("[POST][api/equipment_item] : fail")
                                alert("登録できませんでした");
                            }
                        } else {
                            console.log("[POST][api/equipment_item] : fail")
                            alert("登録できませんでした");
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }
            }
        })       
      },
      // ------------------- END TAB EQUIPMENT ITEM ---------------------
      getClusterInfo: function() { 
        this.$axios
          .get(`/srv/api/area_info/cluster_master`, {
            withCredentials: true,
          })
          .then((response) => {
            console.log("[GET][api/area_info/cluster_masters] : OK");
            if (typeof response.data == "object") {
                this.clusterList = response.data.cluster_masters;
                if (this.clusterList && this.clusterList.length > 0) {
                    this.areaInfoClusterId = this.clusterList[0].cluster_id
                    this.getAreaInfo()
                }
            } else {
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      onChangeAreaInfoClusterId: function(clusterId) {
        this.areaInfoClusterId = clusterId
        this.getAreaInfo()
      },
      getAreaInfo: function() {
        this.$validator.reset('area_info_tab')
        const params = new URLSearchParams();
        params.append("cluster_id", this.areaInfoClusterId);

        const request = {
            params: params,
            withCredentials: true
        };
        this.$axios
          .get(`/srv/api/area_info`, request)
          .then((response) => {
            console.log("[GET][api/area_info] : OK");
            if (typeof response.data == "object") {
                let data = response.data.area_infos
                const length = data.length
                for(let i = length; i < 200; i++) {
                    data.push({
                        area_id: i+1, 
                        cluster_id: this.areaInfoClusterId, 
                        area_name: ''
                    })
                }
                this.areaInfoList = data
                this.$refs["ref-area-info"].scrollIntoView({ behavior: "smooth" })
            } else {
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      onResetAreaInfo: function() {        
        this.getAreaInfo()
      },
      async onRegisterAreaInfo() {
        const isValid = await this.$refs.observerAreaInfo.validate();

        this.$validator.validateAll('area_info_tab').then(valid => {
            if (isValid) {
                const ans = confirm('保存しますか？')
                if (ans) {
                    const params = {
                        'area_infos': this.areaInfoList
                    };
                    this.$axios
                    .post(`/srv/api/area_info`, params, {
                        withCredentials: true
                    })
                    .then(response => {
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][api/area_info] : OK")
                                alert("登録が完了しました。");
                                this.getAreaInfo()
                            } else {
                                console.log("[POST][api/area_info] : fail")
                                alert("登録できませんでした");
                            }
                        } else {
                            console.log("[POST][api/area_info] : fail")
                            alert("登録できませんでした");
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }
            }
        })       
      },
      getUnitInfo: function() {
        this.$validator.reset('unit_info_tab')
        const request = {
            withCredentials: true
        };
        this.$axios
          .get(`/srv/api/unit_info`, request)
          .then((response) => {
            console.log("[GET][api/unit_info] : OK");
            if (typeof response.data == "object") {
                let data = response.data.unit_infos
                const length = data.length
                for(let i = length; i < 100; i++) {
                    data.push({
                        unit_id: i+1,
                        unit_name: ''
                    })
                }
                this.unitInfoList = data
            } else {
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      onResetUnitInfo: function() {        
        this.getUnitInfo()
      },
      async onRegisterUnitInfo() {
        const isValid = await this.$refs.observerUnitInfo.validate();

        this.$validator.validateAll('unit_info_tab').then(valid => {
            if (isValid) {
                const ans = confirm('保存しますか？')
                if (ans) {
                    const params = {
                        'unit_infos': this.unitInfoList
                    };
                    this.$axios
                    .post(`/srv/api/unit_info`, params, {
                        withCredentials: true
                    })
                    .then(response => {
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][api/unit_info] : OK")
                                alert("登録が完了しました。");
                                this.getUnitInfo()
                            } else {
                                console.log("[POST][api/unit_info] : fail")
                                alert("登録できませんでした");
                            }
                        } else {
                            console.log("[POST][api/area_info] : fail")
                            alert("登録できませんでした");
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }
            }
        })       
      },
      getOnOffNameDisplay: function() {
        this.$validator.reset('on_off_display_name_tab')
        const request = {
            withCredentials: true
        };
        this.$axios
          .get(`/srv/api/on_off_display_name`, request)
          .then((response) => {
            console.log("[GET][api/on_off_display_name] : OK");
            if (typeof response.data == "object") {
                let data = response.data.on_off_display_names
                const length = data.length
                for(let i = length; i < 100; i++) {
                    data.push({
                        on_off_name_id: i+1,
                        on_name: '', 
                        off_name: ''
                    })
                }
                this.onOffDisplayNameList = data
            } else {
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      onResetOnOffNameDisplay: function() {        
        this.getOnOffNameDisplay()
      },
      async onRegisterOnOffNameDisplay () {
        const isValid = await this.$refs.observerOnOffDisplayName.validate();

        this.$validator.validateAll('on_off_display_name_tab').then(valid => {
            if (isValid) {
                const ans = confirm('保存しますか？')
                if (ans) {
                    const params = {
                        'on_off_display_names': this.onOffDisplayNameList
                    };
                    this.$axios
                    .post(`/srv/api/on_off_display_name`, params, {
                        withCredentials: true
                    })
                    .then(response => {
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][api/on_off_display_name] : OK")
                                alert("登録が完了しました。");
                                this.getOnOffNameDisplay()
                            } else {
                                console.log("[POST][api/on_off_display_name] : fail")
                                alert("登録できませんでした");
                            }
                        } else {
                            console.log("[POST][api/on_off_display_name] : fail")
                            alert("登録できませんでした");
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }
            }
        })       
      },
      getAlertInfo: function() {
        this.$validator.reset('alert_info_tab')
        const request = {
            withCredentials: true
        };
        this.$axios
          .get(`/srv/api/alert_info`, request)
          .then((response) => {
            console.log("[GET][api/alert_info] : OK");
            if (typeof response.data == "object") {
                let data = response.data.alert_infos
                const length = data.length
                for(let i = length; i < 100; i++) {
                    data.push({
                        alert_name_id: i+1, 
                        on_name: null, 
                        off_name: null
                    })
                }
                this.alertInfoList = data
            } else {
                alert("sesssion time out");
                this.$store.dispatch("logout");
                this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      onResetAlertInfo: function() {
        this.getAlertInfo()
      },
      async onRegisterAlertInfo() {
        const isValid = await this.$refs.observerAlertInfo.validate();

        this.$validator.validateAll('alert_info_tab').then(valid => {
            if (isValid) {
                const ans = confirm('保存しますか？')
                if (ans) {
                    const params = {
                        'alert_infos': this.alertInfoList
                    };
                    this.$axios
                    .post(`/srv/api/alert_info`, params, {
                        withCredentials: true
                    })
                    .then(response => {
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][api/alert_info] : OK")
                                alert("登録が完了しました。");
                                this.getAlertInfo()
                            } else {
                                console.log("[POST][api/alert_info] : fail")
                                alert("登録できませんでした");
                            }
                        } else {
                            console.log("[POST][api/alert_info] : fail")
                            alert("登録できませんでした");
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }
            }
        })       
      },
    },
  
    computed: {
      // Show specific tab
      isShowImportExportTab: function() {
        return this.currentTab === "import_export_tab";
      },
      isShowEquipmentItemTab: function() {
        return this.currentTab === "equipment_item_tab";
      },
      isShowAreaInfoTab: function() {
        return this.currentTab === "area_info_tab";
      },
      isShowUnitInfoTab: function() {
        return this.currentTab === "unit_info_tab";
      },
      isShowOnOffDisplayNameTab: function() {
        return this.currentTab === "on_off_display_name_tab";
      },
      isShowAlertInfoTab: function() {
        return this.currentTab === "alert_info_tab";
      },
    },
  };
  </script>